import Permission from "@/common/components/auth/Permission";
import IventoryCard from "@/common/helpers/inventory-card";
import { FaMotorcycle } from "react-icons/fa";
import { GrMapLocation } from "react-icons/gr";
import { useNavigate } from "react-router-dom";

export const AuditsMenu = () => {
  const navigate = useNavigate();

  return (
    <section className="w-full p-6" >
      <header className="w-full pb-4 mb-6 border-b border-gray-200" >
        <h2 className="text-3xl font-bold text-gray-800 tracking-tight" >📦 Módulo de Auditoria </h2>
      </header>

      < div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6" >
        <Permission permission="view:categories" >
          <div onClick={() => navigate('/audits/vehicles-maintenance')} className="hover:cursor-pointer" >
            <IventoryCard
              icon={<FaMotorcycle />}
              iconSize="70px"
              title="Manutenções"
              iconClassName="text-locavibe"
              className="transition-all duration-300 hover:shadow-xl hover:scale-[1.02] rounded-2xl"
            />
          </div>
        </Permission>

        <Permission permission="view:products" >
          <div onClick={() => navigate('/audits/vehicle-trackers')} className="hover:cursor-pointer" >
            <IventoryCard
              icon={<GrMapLocation />}
              iconSize="70px"
              title="Rastreadores"
              iconClassName="text-locavibe"
              className="transition-all duration-300 hover:shadow-xl hover:scale-[1.02] rounded-2xl"
            />
          </div>
        </Permission>
      </div>
    </section>
  );
}
